<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      合同基本信息
    </div>
    <div class="rj-page-card__content">
      <el-form ref="form" :model="form" :rules="rules" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.createTime }}
              </div>
            </div>
          </div>
          <contract-number ref="contractNumber" v-model="form" :new-contract="newContract" />
          <supply-unit ref="supplyUnit" v-model="form" required @changesupply="changeSupply" />
          <ordering-unit v-model="form" required />
          <end-customer v-model="form" required />
          <order-state v-model="form" required @changeOrderState="changeOrderState" />
          <tax-type v-model="form" required @changeTaxType="changeTaxType" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                净销售额：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="netSales">
                  <el-input v-model="form.netSales" placeholder="请输入净销售额" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                现销或赊销：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="salesType">
                  <el-radio-group v-model="form.salesType">
                    <el-radio v-for="(type,index) in salesType" :key="index" :label="type.code">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <account-period v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                付款方式：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="paymentMethodName">
                  <el-select v-model="form.paymentMethodName" placeholder="请选择付款方式">
                    <el-option v-for="item in paymentMethod" :key="item.label" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <order-type ref="orderType" v-model="form" required />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发货方式：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="shipType">
                  <el-radio-group v-model="form.shipType">
                    <el-radio v-for="(type,index) in shipType" :key="index" :label="type.code">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <pre-sale ref="preSale" v-model="form" required />
          <export-sale ref="exportSale" v-model="form" required />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                部门：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.departmentName }}
              </div>
            </div>
          </div>
          <region-auto ref="regionAuto" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目代码(CRM编号)：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="projectCode">
                  <el-input v-model="form.projectCode" placeholder="请输入项目代码" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="projectName">
                  <el-input v-model="form.projectName" placeholder="请输入项目名称" />
                </el-form-item>
              </div>
            </div>
          </div>
          <region-business ref="regionBusiness" v-model="form" />
          <integrator ref="integrator" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否体现嵌入式产品软件：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="isEmbeddedSoftware">
                  <el-radio-group v-model="form.isEmbeddedSoftware">
                    <el-radio v-for="(type,index) in isEmbeddedSoftware" :key="index" :label="type.code">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <market v-if="form.contractType" ref="market" v-model="form" required />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                借条单号：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="borrowingOrderNumber">
                  <el-input v-model="form.borrowingOrderNumber" placeholder="请输入借条单号" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                CRM客户编码：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="crmAccountCode">
                  <el-input v-model="form.crmAccountCode" placeholder="请输入CRM客户编码" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                特价标志：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="isSpecialPrice">
                  <el-checkbox v-model="form.isSpecialPrice" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                齐套通知打款邮箱<span class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="setNoticeMail">
                  <el-input v-model="form.setNoticeMail" placeholder="请输入齐套通知打款邮箱" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                授权邮箱：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="authorizationEmail">
                  <el-input v-model="form.authorizationEmail" placeholder="请输入授权邮箱" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div v-if="orderUnitDiscount" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                福建/上海/香港通讯下单折扣：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="communicationOrderDiscount">
                  <el-select v-model="form.communicationOrderDiscount" placeholder="福建/上海/香港通讯下单折扣">
                    <el-option v-for="(value, key) in shanghaiHongkongDiscount" :key="key" :label="value" :value="value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="rj-row">
          <payment-bank ref="bank" v-model="form" />
          <div class="rj-col-1">
            <el-form-item prop="additionalTerms" label="补充条款:">
              <el-input v-model.trim="form.additionalTerms" type="textarea" :rows="3" placeholder="请输入补充条款内容" />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="serviceTerms" label="服务条款:" style="margin-top: 10px">
              <el-input v-model.trim="form.serviceTerms" type="textarea" :rows="3" placeholder="请输入服务条款" />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="receiptArrivalAcceptanceRequirements" label="收货回执及到货验收要求:" style="margin-top: 10px">
              <el-input v-model.trim="form.receiptArrivalAcceptanceRequirements" type="textarea" :rows="3" placeholder="请输入收货回执及到货验收要求" />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="remarks" label="备注说明:" style="margin-top: 10px">
              <el-input v-model.trim="form.remarks" type="textarea" :rows="3" placeholder="请输入备注说明" />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script type="es6">
import contractNumber from '../../contractCommonInput/contractNumber';
import supplyUnit from '../../contractCommonInput/supplyUnit';
import orderingUnit from '../../contractCommonInput/orderingUnit';
import EndCustomer from '../../contractCommonInput/EndCustomer';
import baseInfoMixin from '../../orderPersion/createContract/baseInfoMixin';
import { mapState } from 'vuex';
const orderType = () => import('../../contractCommonInput/orderType');
const orderState = () => import('../../contractCommonInput/orderState');
const accountPeriod = () => import('../../contractCommonInput/accountPeriod');
const preSale = () => import('../../contractCommonInput/preSale');
const exportSale = () => import('../../contractCommonInput/exportSale');
const regionAuto = () => import('../../contractCommonInput/regionAuto');
const regionBusiness = () => import('../../contractCommonInput/regionBusiness');
const integrator = () => import('../../contractCommonInput/integrator');
const market = () => import('../../contractCommonInput/market');
const paymentBank = () => import('../../contractCommonInput/paymentBank');
const taxType = () => import('../../contractCommonInput/taxType');
export default {
  mixins: [baseInfoMixin],
  data () {
    var validateEmailAuthorization = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9]+[_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[.|-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/;
      if (!value) {
        callback();
      } else {
        if (this.form.authorizationEmail && this.form.authorizationEmail.length > 100) {
          callback(new Error('输入字符不能超过100'));
        } else if (!mailReg.test(value)) {
          callback(new Error('请输入正确的邮箱格式'));
        } else {
          callback();
        }
      }
    };
    return {
      loading: false,
      paymentMethod: [{
        value: '立即',
        label: '立即付款'
      }],
      rules: {
        customerContractNum: [
          { required: true, message: '请输入客户合同编号', trigger: 'blur' }
        ],
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        supplyUnitId: [
          { required: true, message: '请选择供货单位', trigger: 'change' }
        ],
        orderUnitCode: [
          { required: true, message: '请选择订货单位', trigger: 'change' }
        ],
        finalCustomer: [
          { required: true, message: '请选择择最终客户', trigger: 'change' }
        ],
        contractType: [
          { required: true, message: '请选择订单分类', trigger: 'change' }
        ],
        saleTypeCode: [
          { required: true, message: '请选择订单类型', trigger: 'change' }
        ],
        currencyId: [
          { required: true, message: '请选择币种', trigger: 'change' }
        ],
        preSalesCode: [
          { required: true, message: '请选择售前', trigger: 'change' }
        ],
        salesManCode: [
          { required: true, message: '请选择外销', trigger: 'change' }
        ],
        marketSegmentCode: [
          { required: true, message: '请选择细分市场', trigger: 'change' }
        ],
        setNoticeMail: [
          // { required: true, pattern: /^[a-z0-9A-Z]+[-|a-z0-9A-Z._]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$/, message: '请输入正确的齐套通知打款邮箱', trigger: 'blur' }
          { required: true, message: '请输入齐套通知打款邮箱', trigger: 'blur' }
        ],
        applicationScenariosCode: [
          { required: true, message: '请选择应用场合', trigger: 'change' }
        ],
        authorizationEmail: [
          { validator: validateEmailAuthorization, trigger: 'change' }
        ]
      }
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    newContract: {
      type: String,
      default: ''
    }
  },
  components: {
    contractNumber,
    supplyUnit,
    orderingUnit,
    EndCustomer,
    orderType,
    accountPeriod,
    orderState,
    preSale,
    exportSale,
    regionAuto,
    regionBusiness,
    integrator,
    market,
    paymentBank,
    taxType
  },
  computed: {
    ...mapState({
      moneyType: state => state.enumeration.moneyType,
      salesType: state => state.enumeration.salesType,
      // paymentMethod: state => state.enumeration.paymentMethod,
      shipType: state => state.enumeration.shipType,
      isEmbeddedSoftware: state => state.enumeration.isEmbeddedSoftware,
      shanghaiHongkongDiscount: state => state.enumeration.shanghaiHongkongDiscount
    }),
    orderUnitDiscount () {
      let flag = false;
      if (this.form.orderUnit === '上海锐山网络有限公司' ||
      this.form.orderUnit === '上海爱伟迅数码科技有限公司' ||
      this.form.orderUnit === '星网锐捷（香港）有限公司' ||
      this.form.orderUnit === 'Ruijie Networks Communication Technology Industry and Trade Co., Ltd' ||
      this.form.orderUnit === 'Ruijie Malaysia Sdn. Bhd.' ||
      this.form.orderUnit === '福建省电子器材有限公司'
      ) {
        flag = true;
      }
      return flag;
    }
  },
  methods: {
    setInitData () {
      this.$refs.supplyUnit.initData();
      if (this.$refs.exportSale) {
        this.$refs.exportSale.initData();
      }
      if (this.$refs.orderType) {
        this.$refs.orderType.initContratOrderType();
      }
      if (this.$refs.integrator) {
        this.$refs.integrator.initData();
      }
      if (this.$refs.market) {
        this.$refs.market.initData();
      }
      if (this.$refs.preSale) {
        this.$refs.preSale.initData();
      }
      if (this.$refs.regionAuto) {
        this.$refs.regionAuto.initData();
      }
      if (this.$refs.regionBusiness) {
        this.$refs.regionBusiness.initData();
      }
      if (this.$refs.bank) {
        this.$refs.bank.initData();
      }
    }
  },
  mounted () {

  }
};
</script>
<style lang="scss">
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
</style>
<style lang="scss">
  .baseInfoForm{
    .el-form-item__error{
      position: relative;
    }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
</style>
